(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-card-form]');

      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('[data-product-card-add]');
      var originalText = button ? button.textContent.trim() : 'Add to Cart';
      var formData = new FormData(form);

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      fetch(getShopifyRoot() + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function () {
          window.location.href = getShopifyRoot() + 'cart';
        })
        .catch(function (error) {
          console.error('Product card add to cart error:', error);

          var message =
            error.description ||
            error.message ||
            'This product could not be added to cart.';

          alert(message);

          if (button) {
            button.disabled = false;
            button.textContent = originalText || 'Add to Cart';
          }
        });
    });

    document.addEventListener('click', function (event) {
      var copyButton = event.target.closest('[data-copy-product-link]');

      if (!copyButton) return;

      event.preventDefault();

      var productUrl = copyButton.getAttribute('data-product-url');

      if (!productUrl) return;

      copyToClipboard(productUrl, copyButton);
    });
  });

  function getShopifyRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }

    return '/';
  }

  function copyToClipboard(text, button) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(function () {
          markCopied(button);
        })
        .catch(function () {
          fallbackCopy(text, button);
        });

      return;
    }

    fallbackCopy(text, button);
  }

  function fallbackCopy(text, button) {
    var textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      markCopied(button);
    } catch (error) {
      console.warn('Could not copy product link.', error);
    }

    document.body.removeChild(textarea);
  }

  function markCopied(button) {
    if (!button) return;

    button.classList.add('is-copied');

    setTimeout(function () {
      button.classList.remove('is-copied');
    }, 1200);
  }
})();